import {
  EXP_PROVIDER_ASPIRE,
  EXP_PROVIDER_ASPIRE_PREFIX,
  EXP_PROVIDER_COLLINSON,
  EXP_PROVIDER_COLLINSON_PREFIX,
  EXP_PROVIDER_CUSTOMLINC,
  EXP_PROVIDER_CUSTOMLINC_PREFIX,
  EXP_PROVIDER_DERBYSOFT,
  EXP_PROVIDER_DERBYSOFT_PREFIX,
  EXP_PROVIDER_KLOOK,
  EXP_PROVIDER_KLOOK_PREFIX,
  EXP_PROVIDER_LED,
  EXP_PROVIDER_LED_PREFIX,
  EXP_PROVIDER_REZDY,
  EXP_PROVIDER_REZDY_PREFIX,
} from '~/consts/experiences';

const defineVendorId = (items: Array<App.ExperienceItem>) => {
  const hasMusement = items.some((item) => item.provider === 'mus');
  const hasLED = items.some((item) => item.provider === EXP_PROVIDER_LED_PREFIX);
  const hasRezdy = items.some((item) => item.provider === EXP_PROVIDER_REZDY_PREFIX);
  const hasDerbysoft = items.some((item) => item.provider === EXP_PROVIDER_DERBYSOFT_PREFIX);
  const hasKlook = items.some((item) => item.provider === EXP_PROVIDER_KLOOK_PREFIX);
  const hasAspire = items.some((item) => item.provider === EXP_PROVIDER_ASPIRE_PREFIX);
  const hasCollinson = items.some((item) => item.provider === EXP_PROVIDER_COLLINSON_PREFIX);
  const hasCustomLinc = items.some((item) => item.provider === EXP_PROVIDER_CUSTOMLINC_PREFIX);

  const vendorIds: Array<string> = [];

  if (hasMusement) {
    vendorIds.push('Musement');
  }

  if (hasRezdy) {
    vendorIds.push(EXP_PROVIDER_REZDY);
  }

  if (hasLED) {
    vendorIds.push(EXP_PROVIDER_LED);
  }

  if (hasDerbysoft) {
    vendorIds.push(EXP_PROVIDER_DERBYSOFT);
  }

  if (hasKlook) {
    vendorIds.push(EXP_PROVIDER_KLOOK);
  }

  if (hasAspire) {
    vendorIds.push(EXP_PROVIDER_ASPIRE);
  }

  if (hasCollinson) {
    vendorIds.push(EXP_PROVIDER_COLLINSON);
  }

  if (hasCustomLinc) {
    vendorIds.push(EXP_PROVIDER_CUSTOMLINC);
  }

  return vendorIds.join(' + ');
};
const addonsVendorFormatter = (row: App.Order) => {
  return row.addon_items.length > 0 ? 'Internal LE' : defineVendorId(row.experience_items);
};

export default addonsVendorFormatter;
